'use client';
import { sortBy } from 'lodash';

export const sortByKey = (data, selectedSort) => {

    let filtersData = [...data];
    let { code, name } = selectedSort || {};
    if (name === 'Price: Low to High' && code === 'dsc') {
        filtersData = sortBy(data, 'price');
    }
    if (name === 'Price: High to Low' && code === 'asc') {
        filtersData = sortBy(data, 'price').reverse();
    }
    if (code === 'best seller') {
        filtersData = sortBy(data, 'bestSeller');
    }
    if (code === ' ' && name === 'Featured') {
        filtersData = [...data];
    }
    return filtersData;
}

export const filterByList = [
    { name: 'All', code: ' ' },
    { name: 'Smart Touch Switches', code: 'touch switch' },
    { name: 'Price: High to Low', code: 'asc' },
    { name: 'Best Seller', code: 'best seller' },
]

export const sortByList = [
  { name: "Featured", sortBy: "", order: "" },
  { name: "Price: High to Low", sortBy: "price", order: "dsc" },
  { name: "Price: Low to High", sortBy: "price", order: "asc" },
  { name: "Best Seller", sortBy: "bestSeller", order: "" },
];